module.exports = __webpack_public_path__ + "img/Padding.7c1f119b.svg";